import "./Participants.less";
import {Icon} from "@dp-instant/ui";
import {ParticipantItem} from "@game/ui/interface/ParticipantItem";
import cn from "classnames";

type ParticipantsProps = {users: ParticipantItem[]};

export const Participants = ({users}: ParticipantsProps) => (
    <div className={cn("participants-bar")}>
        {users.map(u => (
            <span className={cn("avatar", "participant")}>
                <span className="avatar-inner" style={{borderColor: u.color}}>
                    {u.data.photo ? (
                        <img src={u.data.photo} alt={u.data.name} />
                    ) : (
                        <Icon type="placeholder-avatar" className="avatar-bg" />
                    )}
                </span>
            </span>
        ))}
    </div>
);
